import { orderBy } from 'lodash'

import type { DropdownOption } from '@acre/design-system'

export const orderAlphabetically = (options: DropdownOption[] | undefined) => {
  return options ? orderBy(options, [(option) => option.label.toLowerCase()], ['asc']) : options
}
